"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var Dropdown_1 = require("office-ui-fabric-react/lib/Dropdown");
var owa_session_store_1 = require("owa-session-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var owa_format_options_1 = require("owa-format-options");
var getDefaultComposeFormat_1 = require("owa-editor/lib/utils/getDefaultComposeFormat");
var FormatButton_1 = require("./FormatButton");
var ColorPickerButton_1 = require("./ColorPickerButton");
var selectFontFamilyOption_1 = require("../actions/selectFontFamilyOption");
var selectFontSizeOption_1 = require("../actions/selectFontSizeOption");
var selectFormattingOption_1 = require("../actions/selectFormattingOption");
var selectTextColorOption_1 = require("../actions/selectTextColorOption");
var owa_options_controls_1 = require("owa-options-controls");
var styles = require('./MessageFormatFull.scss');
var ComposeStyles = /** @class */ (function (_super) {
    tslib_1.__extends(ComposeStyles, _super);
    function ComposeStyles(props) {
        var _this = _super.call(this, props) || this;
        var dividerIndex = 0;
        _this.fontNameItems = owa_format_options_1.FONT_NAME_LIST.map(function (font) {
            if (font.name === '-') {
                return {
                    key: "divider_" + dividerIndex++,
                    itemType: Dropdown_1.DropdownMenuItemType.Divider,
                    text: '-',
                };
            }
            else {
                return {
                    key: font.name,
                    text: font.name,
                };
            }
        });
        _this.fontSizeItems = owa_format_options_1.FONT_SIZES.map(function (size, index) { return ({
            key: owa_format_options_1.getFontSizeFromSizeOrIndex(size),
            text: owa_format_options_1.getFontSizeInPoints(size),
        }); });
        return _this;
    }
    ComposeStyles.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var defaultFontFamily = owa_options_core_1.getFallbackValueIfNull(optionStore.fontFamily, userOptions.ComposeFontName);
        var defaultFontSize = owa_options_core_1.getFallbackValueIfNull(owa_format_options_1.getFontSizeFromSizeOrIndex(optionStore.fontSize), owa_format_options_1.getFontSizeFromSizeOrIndex(userOptions.ComposeFontSize));
        var isBold = owa_options_core_1.getFallbackValueIfNull(optionStore.isFontBold, (userOptions.ComposeFontFlags & 1 /* Bold */) === 1 /* Bold */);
        var isItalic = owa_options_core_1.getFallbackValueIfNull(optionStore.isFontItalic, (userOptions.ComposeFontFlags & 2 /* Italic */) === 2 /* Italic */);
        var isUnderline = owa_options_core_1.getFallbackValueIfNull(optionStore.isFontUnderline, (userOptions.ComposeFontFlags & 4 /* Underline */) === 4 /* Underline */);
        var textStyles = this.getFormatStyles(defaultFontFamily, defaultFontSize, owa_options_core_1.getFallbackValueIfNull(optionStore.fontColor, userOptions.ComposeFontColor), isBold, isItalic, isUnderline);
        return (React.createElement("div", { className: styles.textFormat },
            React.createElement("div", { className: styles.formatBar },
                React.createElement(Dropdown_1.Dropdown, { selectedKey: defaultFontFamily, options: this.fontNameItems, className: styles.fontDropDown, onChanged: this.onFontFamilyChanged }),
                React.createElement(Dropdown_1.Dropdown, { selectedKey: defaultFontSize, options: this.fontSizeItems, className: styles.sizeDropDown, onChanged: this.onFontSizeChanged }),
                React.createElement(FormatButton_1.default, { type: "bold", isSelected: isBold, onClick: this.onBoldClicked }),
                React.createElement(FormatButton_1.default, { type: "italic", isSelected: isItalic, onClick: this.onItalicClicked }),
                React.createElement(FormatButton_1.default, { type: "underline", isSelected: isUnderline, onClick: this.onUnderlineClicked }),
                React.createElement(ColorPickerButton_1.default, { onSelectColor: selectTextColorOption_1.default })),
            React.createElement("div", { className: styles.sampleText, style: textStyles },
                React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_format_sampleText_1),
                React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_format_sampleText_2))));
    };
    ComposeStyles.prototype.onFontFamilyChanged = function (option, index) {
        selectFontFamilyOption_1.default(option.key);
    };
    ComposeStyles.prototype.onFontSizeChanged = function (option, index) {
        selectFontSizeOption_1.default(option.key);
    };
    ComposeStyles.prototype.onBoldClicked = function (isSelected) {
        selectFormattingOption_1.default('isFontBold', isSelected);
    };
    ComposeStyles.prototype.onItalicClicked = function (isSelected) {
        selectFormattingOption_1.default('isFontItalic', isSelected);
    };
    ComposeStyles.prototype.onUnderlineClicked = function (isSelected) {
        selectFormattingOption_1.default('isFontUnderline', isSelected);
    };
    ComposeStyles.prototype.getFormatStyles = function (fontFamily, fontSize, fontColor, isBold, isItalic, isUnderline) {
        var composeFormat = getDefaultComposeFormat_1.getComposeFormat(fontFamily, fontSize, fontColor, 0);
        return {
            fontFamily: composeFormat.fontFamily,
            fontSize: composeFormat.fontSize,
            color: composeFormat.textColor,
            fontWeight: isBold ? 'bold' : undefined,
            fontStyle: isItalic ? 'italic' : undefined,
            textDecoration: isUnderline ? 'underline' : undefined,
        };
    };
    ComposeStyles = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], ComposeStyles);
    return ComposeStyles;
}(React.Component));
exports.default = ComposeStyles;
//# sourceMappingURL=ComposeStyles.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-format-option/lib/components/ComposeStyles.js
// module id = 5148
// module chunks = 2